import { IField } from "../interfaces/inputs/IField";

export const LocationFields: IField[] = [
  { name: "name", type: "text", label: "Name", size: {lg: 6}, position: 1 },
  { name: "code", type: "text", label: "Code", size: {lg: 6}, position: 2 }
].sort((a: IField, b: IField) => a.position - b.position);